import { partialParse } from "openai-partial-json-parser";
import {
  AskAiChatMessageFragmentFragment,
  ChatbotRoleEnum,
  GetAskAiChatSessionHistoryQueryQuery,
  GetAskAiChatSessionQueryQuery,
} from "types/graphql-schema";
import { v4 as uuidv4 } from "uuid";

import { assertEdgesNonNullWithStringId } from "@helpers/helpers";

export const askAIPlaceholderDebounceTime = 100;

type OutputItemPartialType = NonNullable<
  AskAiChatMessageFragmentFragment["outputItems"]
>[number];

export const createChatMessageOutputItemNode = (
  partialChatMessageOutputItem: Partial<NonNullable<OutputItemPartialType>>,
): OutputItemPartialType => ({
  __typename: "ChatMessageOutputItemNode",
  type: partialChatMessageOutputItem.type || "",

  text: partialChatMessageOutputItem.text || null,
  actionItems: partialChatMessageOutputItem.actionItems || null,
  goals: partialChatMessageOutputItem.goals || null,
  recognitions: partialChatMessageOutputItem.recognitions || null,
  feedback: partialChatMessageOutputItem.feedback || null,
  suggestedAssessmentResponses:
    partialChatMessageOutputItem.suggestedAssessmentResponses || null,
  suggestedRecognition:
    partialChatMessageOutputItem.suggestedRecognition || null,
  suggestedFeedback: partialChatMessageOutputItem.suggestedFeedback || null,
  suggestedActionItem: partialChatMessageOutputItem.suggestedActionItem || null,
  suggestedGoal: partialChatMessageOutputItem.suggestedGoal || null,
  goalProgressUpdates: partialChatMessageOutputItem.goalProgressUpdates || null,
  overviewDirectReports:
    partialChatMessageOutputItem.overviewDirectReports || null,
  overviewUser: partialChatMessageOutputItem.overviewUser || null,
  suggestedMeetingTopics:
    partialChatMessageOutputItem.suggestedMeetingTopics || null,
  externalEvents: partialChatMessageOutputItem.externalEvents || null,
  meetings: partialChatMessageOutputItem.meetings || null,
});

export const createChatMessageNode = (
  partialChatMessage: Partial<AskAiChatMessageFragmentFragment>,
): AskAiChatMessageFragmentFragment => ({
  __typename: "ChatMessageNode",
  id: uuidv4(),
  role: ChatbotRoleEnum.User,
  content: "",
  imageUrls: [],

  error: false,
  autogenerated: false,
  isStreaming: false,

  createdArtifact: null,
  outputItems: [],
  toolCalls: [],

  ...partialChatMessage,
});

export const parsePartialJson = (jsonStr: string) => {
  return partialParse(jsonStr);
};

export const getChatSessionTitle = (
  chatSession:
    | GetAskAiChatSessionQueryQuery["chatSession"]
    | NonNullable<
        NonNullable<
          GetAskAiChatSessionHistoryQueryQuery["chatSessions"]
        >["edges"][number]
      >["node"],
) => {
  if (chatSession?.assessmentQuestion?.title) {
    return `Context: ${chatSession.assessmentQuestion.title}`;
  }
  const messages = chatSession?.messages
    ? assertEdgesNonNullWithStringId(chatSession.messages)
    : [];
  const firstMessage = messages.find(
    (message) => message.role === ChatbotRoleEnum.User,
  );
  return (
    firstMessage?.content ||
    (firstMessage?.imageUrls.length ? "Image message" : undefined)
  );
};
